<div
  *ngIf="!app_mode && !client_app_mode"
  class="header"
  [class.header__erp-mode-dev]="!isProd"
  [class.header__erp-mode-prod]="erp_mode && isProd"
>
  <div class="container">
    <a
      *ngIf="!erp_mode"
      [href]="goToPublic"
      routerLinkActive="router-link-active"
      class="header__logo"
    >
      <img
        *ngIf="!agencyData?.id && !isBusinessMode"
        src="assets/images/Aparca_go_logo.svg"
        alt="Aparca&Go"
      />
      <img
        *ngIf="!agencyData?.id && isBusinessMode"
        src="assets/images/a&go_logo_business.svg"
        alt="Aparca&Go"
      />
      <img
        *ngIf="agencyData?.id"
        class="header__agency"
        src="assets/images/logo-agencias.svg"
        alt="Aparca&Go"
      />
    </a>
    <a
      *ngIf="erp_mode"
      [href]="goToErpReservation"
      routerLinkActive="router-link-active"
      class="header__erp-mode-dev-text"
    >
      {{ 'sharedModule.bkgSignUpDialog.cancel' | translate }}
    </a>

    <div class="header__nav">
      <div class="header__lang">
        <div class="dropdown">
          <bkg-language-selector [erpMode]="erp_mode"></bkg-language-selector>
        </div>
      </div>

      <div *ngIf="hasAuthData && !erp_mode" class="header__logged dropdown">
        <button
          type="button"
          class="header__logged-trigger"
          data-bs-toggle="dropdown"
          id="dropdownUserMenu"
          aria-haspopup="true"
          aria-controls="menuUser"
          aria-expanded="false"
        >
          <div class="header__logged-avatar'">
            <img
              *ngIf="!isBusinessMode"
              src="assets/images/icons/user.svg"
              alt=""
            />
            <img
              *ngIf="isBusinessMode"
              src="assets/images/icons/user-business.svg"
              alt=""
            />
          </div>
          <div class="header__logged-info">
            <span *ngIf="!isBusinessMode" class="header__logged-greeting">{{
              'sharedModule.bkgHeader.greeting' | translate
            }}</span>
            <span *ngIf="isBusinessMode" class="header__logged-greeting">{{
              companyName
            }}</span>
            <span *ngIf="userData?.id" class="header__logged-name"
              >{{ userData?.name }} {{ userData?.lastName }}</span
            >
            <span *ngIf="agencyData?.id" class="header__logged-name">{{
              agencyData?.company_name
            }}</span>
          </div>
        </button>
        <ul
          class="dropdown-menu"
          id="menuUser"
          role="menu"
          aria-labelledby="dropdownUserMenu"
        >
          <li role="none">
            <a
              class="dropdown-item link"
              [href]="accountLink"
              role="menuitem"
              >{{ 'sharedModule.bkgHeader.account' | translate }}</a
            >
          </li>
          <li role="none">
            <a
              class="dropdown-item link"
              [href]="reservationsLink"
              role="menuitem"
              >{{ 'sharedModule.bkgHeader.reservation' | translate }}</a
            >
          </li>
          <li
            role="none"
            *ngIf="!isBusinessMode && companyProfiles"
            (click)="openChangeUserModeDialog()"
          >
            <a class="dropdown-item link business-mode" role="menuitem">{{
              'sharedModule.bkgHeader.businessMode' | translate
            }}</a>
          </li>
          <li
            role="none"
            *ngIf="isBusinessMode"
            (click)="openChangeUserModeDialog()"
          >
            <a class="dropdown-item link individual-mode" role="menuitem">{{
              'sharedModule.bkgHeader.individualMode' | translate
            }}</a>
          </li>
          <li role="none">
            <a
              (click)="onClickLogout()"
              class="dropdown-item link"
              role="menuitem"
            >
              {{ 'sharedModule.bkgHeader.logout' | translate }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="header__mobile-triggers">
      <div class="header__lang">
        <div class="dropdown">
          <bkg-language-selector [erpMode]="erp_mode"></bkg-language-selector>
        </div>
      </div>
      <ng-container *ngIf="hasAuthData && !erp_mode">
        <button
          type="button"
          id="show-login-drawer"
          aria-label="Acceder"
          class="header__mobile-login-trigger"
          data-bs-toggle="dropdown"
          id="dropdownUserMenu"
          aria-haspopup="true"
          aria-controls="menuUserM"
          aria-expanded="false"
        >
          <img
            *ngIf="!isBusinessMode"
            src="assets/images/icons/user.svg"
            alt=""
          />
          <img
            *ngIf="isBusinessMode"
            src="assets/images/icons/user-business.svg"
            alt=""
          />
        </button>
        <ul
          class="dropdown-menu"
          id="menuUserM"
          role="menu"
          aria-labelledby="show-login-drawer"
        >
          <li role="none">
            <a class="dropdown-item" [href]="accountLink" role="menuitem">{{
              'sharedModule.bkgHeader.account' | translate
            }}</a>
          </li>
          <li role="none">
            <a
              class="dropdown-item"
              [href]="reservationsLink"
              role="menuitem"
              >{{ 'sharedModule.bkgHeader.reservation' | translate }}</a
            >
          </li>
          <li
            role="none"
            *ngIf="!isBusinessMode"
            (click)="openChangeUserModeDialog()"
          >
            <a class="dropdown-item link business-mode" role="menuitem">{{
              'sharedModule.bkgHeader.businessMode' | translate
            }}</a>
          </li>
          <li
            role="none"
            *ngIf="isBusinessMode"
            (click)="openChangeUserModeDialog()"
          >
            <a class="dropdown-item link individual-mode" role="menuitem">{{
              'sharedModule.bkgHeader.individualMode' | translate
            }}</a>
          </li>
          <li role="none">
            <a (click)="onClickLogout()" class="dropdown-item" role="menuitem">
              {{ 'sharedModule.bkgHeader.logout' | translate }}</a
            >
          </li>
        </ul>
      </ng-container>
    </div>
    <div *ngIf="!hasAuthData && !erp_mode" class="header__lang">
      <button (click)="openLoginModal()" class="btn" type="button">
        {{ 'sharedModule.bkgHeader.login' | translate }}
      </button>
    </div>
  </div>
</div>
<bkg-banner
  [message]="userMessage?.message"
  [isVisible]="!!userMessage?.message"
  [isErrorBanner]="userMessage?.errorMessage"
  [isWarningBanner]="userMessage?.warningMessage"
  (closeBanner)="cleanMessages()"
></bkg-banner>
<div id="centerScreen" class="center-screen"></div>
